module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticesPosing.png
// module id = 2439
// module chunks = 2